import { IHidden } from "@faire/retailer-visitor-shared/features/IDV/commonTypes";
import { Column } from "@faire/web/slate/Layout";
import React, { PropsWithChildren } from "react";

// This component wraps its children in a Column with a display none if "hidden" is true.
export const Hidden: React.FC<PropsWithChildren<IHidden>> = ({
  hidden,
  children,
}) => {
  return (
    <Column aria-hidden={hidden} style={{ display: hidden ? "none" : "flex" }}>
      {children}
    </Column>
  );
};
